<div class="card card-user">
    <div class="card-header">
        <h4 class="card-title">Widgets</h4>
    </div>
    <div class="card-body">
        <div class="container mt-3">
            <!-- botones generales -->
            <div class="mb-2" *ngIf="!showForm">
                <button class="btn btn-sm btn-primary" (click)="addNew()">Nuevo</button>
            </div>

            <!-- lista de mini‑cards para cada entidad -->
            <div class="mb-3" *ngIf="!showForm && records.length">
                <div class="row">
                    <div class="col-6 col-md-4 col-lg-3 mb-2" *ngFor="let rec of records; let i = index">
                        <div class="card card-small" [class.border-primary]="i === currentIndex">
                            <div class="card-body p-2">
                            <p class="card-text small mb-1">ID {{rec.id}}</p>
                                <h6 class="card-title mb-1">{{rec.displayName || rec.name}}</h6>
                                <p class="card-text small mb-1">{{rec.role}}</p>
                                <p class="card-text small mb-1">{{rec.applicationId}}</p>
                                <p class="card-text small text-truncate" style="max-width:100%">{{rec.description}}</p>
                                <button class="btn btn-sm btn-outline-primary mt-1" (click)="loadRecord(i)">Editar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- formulario edit/create -->
            <form *ngIf="showForm && currentRecord" novalidate autocomplete="off">
                <div class="form-row">
                    <div class="form-group col-md-4">
                        <label>Nombre</label>
                        <input class="form-control" [(ngModel)]="currentRecord.name" name="name">
                    </div>
                    <div class="form-group col-md-4">
                        <label>Display</label>
                        <input class="form-control" [(ngModel)]="currentRecord.displayName" name="displayName">
                    </div>
                    <div class="form-group col-md-4">
                        <label>Icono</label>
                        <input class="form-control" [(ngModel)]="currentRecord.icon" name="icon">
                    </div>
                </div>

                <div class="form-group">
                    <label>Descripción</label>
                    <textarea class="form-control" rows="2" [(ngModel)]="currentRecord.description"
                        name="description"></textarea>
                </div>

                <div class="form-row">
                    <div class="form-group col-md-3">
                        <label>Application</label>
                        <select class="form-control" [(ngModel)]="currentRecord.applicationId" name="applicationId">
                            <option *ngFor="let app of applicationOptions" [value]="app.id">{{app.label}}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-3">
                        <label>Rol</label>
                        <select class="form-control" [(ngModel)]="currentRecord.role" name="role">
                            <option *ngFor="let r of roleOptions">{{r}}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-3">
                        <label>SP Name</label>
                        <input class="form-control" [(ngModel)]="currentRecord.spName" name="spName">
                    </div>
                    <div class="form-group col-md-3">
                        <label>¿Listo?</label><br>
                        <input type="checkbox" [(ngModel)]="currentRecord.isReady" name="isReady">
                    </div>
                </div>

                <div class="form-group">
                    <label>Template</label>
                    <textarea class="form-control" rows="2" [(ngModel)]="currentRecord.template"
                        name="template"></textarea>
                </div>

                <div class="form-group">
                    <label>JSON Test Data</label>
                    <textarea class="form-control" rows="2" [(ngModel)]="currentRecord.jsonTestData"
                        name="jsonTestData"></textarea>
                </div>

                <div class="mt-2">
                    <button class="btn btn-success mr-2" type="button" (click)="save()">Guardar</button>
                    <button class="btn btn-secondary mr-2" type="button" (click)="cancel()">Cancelar</button>
                    <select class="form-control d-inline-block w-auto mr-2" [(ngModel)]="previewFormat" name="previewFormat">
                      <option value="html">HTML</option>
                      <option value="xml">XML</option>
                    </select>
                    <button class="btn btn-warning" type="button" (click)="openPreview()">Preview</button>
                </div>

                <!-- preview modal -->
                <div class="modal" tabindex="-1" [ngClass]="{'show d-block':showPreview}" role="dialog">
                  <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title">Preview ({{previewFormat.toUpperCase()}})</h5>
                        <button type="button" class="close" (click)="closePreview()">
                          <span>&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <pre *ngIf="previewFormat==='xml'" style="white-space: pre-wrap; word-break: break-word;">{{previewResult}}</pre>
                        <div *ngIf="previewFormat==='html'" [innerHTML]="previewResult"></div>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" (click)="closePreview()">Cerrar</button>
                      </div>
                    </div>
                  </div>
                </div>
            </form>

        </div>

    </div>
</div>